export let onClickFunction = (entry) => {
    let element = document.getElementById("rowNr--" + entry.nr)
    if (element) {
        if (element.style.visibility == "visible") {
            setTimeout(() => {
                element.style.visibility = "hidden"
                element.style.height = "0px"
            }, 600)
        } else {
            element.style.visibility = "visible"
            element.style.height = "auto"
        }
        let btn = element.getElementsByClassName("opener")
        btn[0]?.click()
    }
}
